import { imageUrl } from "../utils/imagePath";
import { useHistory } from "react-router";
import config from "../config";
import "./navbar.scss";
import { Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { logout, clearStorageOnLogout } from "../services/auth";
import axiosObj from "../config/axios";

const MegaHeader = () => {
  const [boxShadowColor, setBoxShadowColor] = useState(
    "rgba(255, 255, 255, 0.5)"
  );

  const getRandomColor = () => {
    const r = Math.floor(Math.random() * 256);
    const g = Math.floor(Math.random() * 256);
    const b = Math.floor(Math.random() * 256);
    return `rgba(${r}, ${g}, ${b}, 1)`;
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setBoxShadowColor(getRandomColor());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const [showModal, setShowModal] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);
  const history = useHistory();

  useEffect(() => {
    if (!showUserMenu) return;
    const closeMenu = () => setShowUserMenu(false);
    document.addEventListener("click", closeMenu);
    return () => document.removeEventListener("click", closeMenu);
  }, [showUserMenu]);

  useEffect(() => {
    if (!activeDropdown) return;
    const closeDropdown = () => setActiveDropdown(null);
    document.addEventListener("click", closeDropdown);
    return () => document.removeEventListener("click", closeDropdown);
  }, [activeDropdown]);

  const toggleDropdown = (dropdownKey) => {
    setActiveDropdown((currentDropdown) =>
      currentDropdown === dropdownKey ? null : dropdownKey
    );
  };

  const handleLogout = async () => {
    try {
      const user = JSON.parse(localStorage.getItem(config.keys.user) || "null");
      if (user && !user.isGuest) {
        await logout();
      }
    } catch (err) {
      // proceed to clear local state even if API fails
    }
    clearStorageOnLogout();
    axiosObj.removeHeaders();
    window.location = config.routes.login;
  };

  return (
    <>
      <header className="mega-header">
        <nav className="navbar navbar-expand-lg sticky-navbar p-0">
          <div className="container-fluid ps-5 pe-4">
            <img
              src={imageUrl("mega-header", "Group 31.png")}
              alt="Data Pilot logo"
              height={40}
              width={45}
              className="header-logo"
              onClick={(event) => {
                event.stopPropagation();
                history.push(config.routes.maindashboard);
              }}
            />
            <button
              className="navbar-toggler collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbar-content"
              aria-label="Toggle navigation"
            >
              <i className="fas fa-stream text-white" />
            </button>
            <div className="collapse navbar-collapse" id="navbar-content">
              <ul className="navbar-nav mx-5 mb-2 mb-lg-0">
                <li
                  className={`nav-item dropdown dropdown-mega ${
                    activeDropdown === "ai-data-analytics" ? "open" : ""
                  }`}
                >
                  <a
                    className="nav-link my-2"
                    data-bs-auto-close="outside"
                    href="#"
                    aria-expanded={activeDropdown === "ai-data-analytics"}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      toggleDropdown("ai-data-analytics");
                    }}
                  >
                    Business Intelligence
                  </a>
                  <div className="dropdown-menu shadow ">
                    <div className="mega-content px-md-4">
                      <div className="container-fluid">
                        <div className="row">
                          <div
                            className="col-lg-12 col-sm-12 py-4 px-xl-4 px-3 mega-nav-col-ai"
                          >
                            <div className="list-group">
                              <a
                                className="list-group-item"
                                href={config.routes.GenAi}
                                onClick={(e) => {
                                  e.preventDefault();
                                  history.push(config.routes.GenAi);
                                }}
                              >
                                Generative AI (GenAI) Implementation
                              </a>
                              <a
                                className="list-group-item"
                                href={config.routes.OcrCaseStudy}
                                onClick={(e) => {
                                  e.preventDefault();
                                  history.push(config.routes.OcrCaseStudy);
                                }}
                              >
                                Optical Character Recognition (OCR) Solutions
                              </a>
                              <a
                                className="list-group-item"
                                href="/Paid-and-Organic-media-analytics"
                              >
                                Paid and Organic Media Analytics
                              </a>
                              <a
                                className="list-group-item"
                                href={config.routes.LinkedInRoute}
                                onClick={(e) => {
                                  e.preventDefault();
                                  history.push(config.routes.LinkedInRoute);
                                }}
                              >
                                LinkedIn Analytics Integration
                              </a>
                              <a
                                className="list-group-item"
                                href={config.routes.Hubspot}
                                onClick={(e) => {
                                  e.preventDefault();
                                  history.push(config.routes.Hubspot);
                                }}
                              >
                                HubSpot Email Statistics{" "}
                              </a>
                              <a
                                className="list-group-item"
                                href="/Churn-Prediction-Analytics"
                              >
                                Churn Prediction Analytics
                              </a>
                              <a
                                className="list-group-item"
                                href="/ai-powered-qa-automation-agent"
                                onClick={(e) => {
                                  e.preventDefault();
                                  history.push(config.routes.ADS);
                                }}
                              >
                                AI-Powered QA Automation Agent
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>

                <li
                  className={`nav-item dropdown dropdown-mega ${
                    activeDropdown === "retail-ecommerce" ? "open" : ""
                  }`}
                >
                  <a
                    className="nav-link my-2"
                    data-bs-auto-close="outside"
                    href="#"
                    aria-expanded={activeDropdown === "retail-ecommerce"}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      toggleDropdown("retail-ecommerce");
                    }}
                  >
                    Retail & E-Commerce
                  </a>
                  <div className="dropdown-menu shadow">
                    <div className="mega-content px-md-4">
                      <div className="container-fluid">
                        <div className="row">
                          <div
                            className="col-lg-12 col-sm-12 py-4 px-xl-4 px-3 mega-nav-col-retail"
                          >
                            <div className="list-group">
                              <a
                                className="list-group-item"
                                href={config.routes.Lulusar}
                                onClick={(e) => {
                                  e.preventDefault();
                                  history.push(config.routes.Lulusar);
                                }}
                              >
                                Omni-Channel Analytics{" "}
                              </a>
                              <a
                                className="list-group-item"
                                href={config.routes.Levis}
                                onClick={(e) => {
                                  e.preventDefault();
                                  history.push(config.routes.Levis);
                                }}
                              >
                                AI Defect Detection
                              </a>
                              <a
                                className="list-group-item"
                                href={config.routes.Elm}
                                onClick={(e) => {
                                  e.preventDefault();
                                  history.push(config.routes.Elm);
                                }}
                              >
                                ELM
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>

                <li
                  className={`nav-item dropdown dropdown-mega ${
                    activeDropdown === "logistics-utilities" ? "open" : ""
                  }`}
                >
                  <a
                    className="nav-link my-2"
                    data-bs-auto-close="outside"
                    href="#"
                    aria-expanded={activeDropdown === "logistics-utilities"}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      toggleDropdown("logistics-utilities");
                    }}
                  >
                    Logistics & Utilities{" "}
                  </a>
                  <div className="dropdown-menu shadow">
                    <div className="mega-content px-md-4">
                      <div className="container-fluid">
                        <div className="row">
                          <div
                            className="col-lg-12 col-sm-12 py-4 px-xl-4 px-3 mega-nav-col-logistics"
                          >
                            <div className="list-group">
                              <a
                                className="list-group-item"
                                href={config.routes.FTRoute}
                                onClick={(e) => {
                                  e.preventDefault();
                                  history.push(config.routes.FTRoute);
                                }}
                              >
                                Fleet Tracking & Dead-Zone Mapping
                              </a>
                              <a
                                className="list-group-item"
                                href="/ai-powered-product-intelligence-equivalent-mapping-platform"
                                onClick={(e) => {
                                  e.preventDefault();
                                  history.push(config.routes.Spartan);
                                }}
                              >
                                AI-Powered Product Intelligence &amp;
                                Equivalent Mapping Platform
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>

                <li
                  className={`nav-item dropdown dropdown-mega ${
                    activeDropdown === "strategy-growth" ? "open" : ""
                  }`}
                >
                  <a
                    className="nav-link my-2"
                    data-bs-auto-close="outside"
                    href="#"
                    aria-expanded={activeDropdown === "strategy-growth"}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      toggleDropdown("strategy-growth");
                    }}
                  >
                    Strategy and Growth{" "}
                  </a>
                  <div className="dropdown-menu shadow">
                    <div className="mega-content px-md-4">
                      <div className="container-fluid">
                        <div className="row">
                          <div
                            className="col-lg-12 col-sm-12 py-4 px-xl-4 px-3 mega-nav-col-strategy"
                          >
                            <div className="list-group">
                              <a
                                className="list-group-item"
                                href={config.routes.PSW}
                                onClick={(e) => {
                                  e.preventDefault();
                                  history.push(config.routes.PSW);
                                }}
                              >
                                Pakistan Single Window (PSW){" "}
                              </a>
                              <a
                                className="list-group-item"
                                href="/ai-powered-cost-estimation-quoting-platform"
                                onClick={(e) => {
                                  e.preventDefault();
                                  history.push(config.routes.Outform);
                                }}
                              >
                                AI-Powered Cost Estimation &amp; Quoting Platform
                              </a>
                              <a
                                className="list-group-item"
                                href="/datatram-marketing-analytics-platform"
                                onClick={(e) => {
                                  e.preventDefault();
                                  history.push(config.routes.Datatram);
                                }}
                              >
                                DataTram Marketing Analytics Platform
                              </a>
                              <a
                                className="list-group-item"
                                href="/ai-powered-product-channel-optimisation-platform"
                                onClick={(e) => {
                                  e.preventDefault();
                                  history.push(config.routes.DFS);
                                }}
                              >
                                AI-Powered Product &amp; Channel Optimisation
                                Platform
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>

                <li
                  className={`nav-item dropdown dropdown-mega ${
                    activeDropdown === "pharma-healthcare" ? "open" : ""
                  }`}
                >
                  <a
                    className="nav-link my-2"
                    data-bs-auto-close="outside"
                    href="#"
                    aria-expanded={activeDropdown === "pharma-healthcare"}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      toggleDropdown("pharma-healthcare");
                    }}
                    role="button"
                    tabIndex={0}
                  >
                    Pharma & Healthcare
                  </a>
                  <div className="dropdown-menu shadow">
                    <div className="mega-content px-md-4">
                      <div className="container-fluid">
                        <div className="row">
                          <div
                            className="col-lg-12 col-sm-12 py-4 px-xl-4 px-3 mega-nav-col-pharma"
                          >
                            <div className="list-group">
                              <a
                                className="list-group-item"
                                href="/competitive-landscape-monitoring-platform"
                                onClick={(e) => {
                                  e.preventDefault();
                                  history.push(config.routes.CompetitiveLandscape);
                                }}
                              >
                                Competitive Landscape Monitoring Platform
                              </a>
                              <a
                                className="list-group-item"
                                href="/ai-powered-medical-research-intelligence-platform"
                                onClick={(e) => {
                                  e.preventDefault();
                                  history.push(config.routes.MedicalResearchIntelligencePlatform);
                                }}
                              >
                                AI-Powered Medical Research Intelligence Platform
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
              <div className="d-flex align-items-center user-menu-wrapper">
                <button
                  onClick={handleShow}
                  className="glow-button"
                  style={{ "--glow-color": boxShadowColor }}
                >
                  Subscribe
                </button>
                <div className="d-none d-lg-block position-relative avatar-wrapper">
                  <button
                    className="btn btn-link p-0 border-0 text-decoration-none"
                    type="button"
                    aria-label="User menu"
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowUserMenu((prev) => !prev);
                    }}
                  >
                    <img
                      src={imageUrl("mega-header", "circle-user.png")}
                      alt="User"
                      className="user-menu-icon"
                    />
                  </button>
                  {showUserMenu && (
                    <ul
                      className="user-menu-dropdown shadow"
                      role="menu"
                    >
                      <li role="none">
                        <button
                          type="button"
                          role="menuitem"
                          className="user-menu-dropdown-item"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleLogout();
                          }}
                        >
                          <i className="fas fa-sign-out-alt me-2" aria-hidden />
                          Logout
                        </button>
                      </li>
                    </ul>
                  )}
                </div>
              </div>
          </div>
        </nav>
      </header>

      <Modal
        show={showModal}
        onHide={handleClose}
        className="custom-modal"
        centered
      >
        <Modal.Header closeButton className="modal-header">
          <Modal.Title>Join the Data Pilot Revolution</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="subscribe-modal-body">
            <iframe
              src="https://share.hsforms.com/1g3wzZJv8SCKDQsYm7P_QlAco659"
              title="Subscribe to Data Pilot"
              className="subscribe-modal-iframe"
              allowFullScreen
            />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default MegaHeader;
